import React from 'react';
import CommonHeader from '../components/Headers/CommonHeader';
import ChatBot from '@/components/ChatBot/ChatBot';

export default function ChatBotPage() {
  return (
    <React.Fragment>
      <div style={{ minHeight: '100vh' }}>
        <CommonHeader className="aida_banner" />
        <ChatBot />
      </div>
    </React.Fragment>
  );
}
